import { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, Alert } from '@mui/material';
import { useAuth } from './AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError('Credenziali non valide o account non autorizzato.');
    }
    setLoading(false);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper sx={{ p: 4, width: '100%', maxWidth: 400 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/logo-auctoris-light.png`}
            alt="AUCTORIS"
            sx={{ maxHeight: 104, maxWidth: 260, objectFit: 'contain', mb: 1.5, display: 'block', mx: 'auto' }}
          />
          <Typography variant="body2" color="text.secondary">Accesso staff HUB</Typography>
        </Box>
        <form onSubmit={submit}>
          <TextField fullWidth label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 2 }} required />
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Button fullWidth type="submit" variant="contained" disabled={loading}>{loading ? 'Accesso...' : 'Entra'}</Button>
        </form>
      </Paper>
    </Box>
  );
}